import { makeStyles, Theme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 25,
    color: 'black',
  },
  inputTwo: {
    color: 'grey',
    width: '98%',
    '& .MuiInputBase-input': {
      padding: '18px 0 6px',
    },

    '& .MuiPhoneNumber-flagButton': {
      marginTop: '15px',
    },
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    width: 170,
    color: 'rgb(0 0 0 / 70%)',
  },
  paper: {
    paddingTop: theme.spacing(1),
    padding: theme.spacing(3),
    width: '60%',
  },
  btn: {
    marginTop: theme.spacing(5),
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  textField: {
    width: '100%',
    marginRight: theme.spacing(2),
    color: 'rgb(0 0 0 / 87%)',
    marginBottom: '10px',
  },
  row: {
    margin: theme.spacing(3, 3, 0, 0),
  },
  keywordTitle: {
    margin: theme.spacing(6, 3, 0, 0),
  },
  keywords: {
    marginLeft: theme.spacing(3),
    color: blue[700],
  },
  cancelButton: {
    backgroundColor: 'white',
  },
}));
